// En este archivo se pueden crear enums para cuando sea necesario distinguir usos distintos del mismo componente.

// Enum en reactjs
export const StudentOrTutor = Object.freeze({
    STUDENT: "student",
    TUTOR: "tutor",
});